import styled from 'styled-components';
import { mediaQuery } from 'modules/utils';
import { Link } from 'react-router-dom';

export const StyledSocialLinksList = styled.div`
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;

  li:first-child {
    margin-right: 0.5rem;
  }

  li:not(:first-child):not(:last-child) {
    margin: 0 0.5rem;
  }

  li:last-child {
    margin-left: 0.5rem;
  }
`;

export const StyledSocialLink = styled(Link)`
  height: 2.2rem;
  width: 2.2rem;

  ${mediaQuery('md')} {
    height: 1.7rem;
    width: 1.7rem;
  }

  display: flex;
  align-items: center;
  justify-content: center;

  * {
    width: 100%;
    height: 100%;
  }
`;
